import { Action } from "@ngrx/store";
import * as types from "./constants/cart.constant";
import { CheckoutDataState } from "../../Entites/checkoutDataState";
import { CheckoutDataFeed } from "../../Entites/checkoutFeed";



// product details




export class Request_CHECKOUT_ACTION implements Action
{

   readonly type: string = types.checkOutOrderTotal;
   constructor( public data: CheckoutDataFeed ){}

}

export class Request_CHECKOUT_Loaded implements Action
{

   readonly type: string = types.checkOrderTotalLoaded;
   constructor( public data: CheckoutDataState ){}

}
export class Request_CHECKOUT_ACTION_Update implements Action
{

   readonly type: string = types.checkOrderFeedStatus;
   constructor( public data: CheckoutDataFeed ){}

}
export class Select_BRANCH_ForCHeckout implements Action
{

   readonly type: string = types.selectBranchForCheckout;
   constructor( public data: number ){}

}


export class CHECK_VOUCHER_ACTION implements Action
{

   readonly type: string = types.CHECK_VOUCHER;

   constructor(public data: string){}

}

export class CHANGE_DELIVERY_TYPE_ACTION implements Action
{

   readonly type: string = types.CHANGE_DELIVERY_TYPE;

   constructor(public data: boolean){}

}


export type ActionsUnion =  CHECK_VOUCHER_ACTION | Request_CHECKOUT_Loaded | Request_CHECKOUT_ACTION ;
